import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import urPK from 'antd/locale/ur_PK';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { isRtl } from './i18n';
import { salesTheme } from './theme/salesTheme';
import './i18n';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

/**
 * Feeds the active language into antd, so its own built-in strings (date pickers, pagination,
 * table filters, empty states) switch with the app rather than staying English, and the whole
 * layout mirrors for Urdu. Kept as a component so a language change re-renders the provider.
 */
function Root() {
  const { i18n } = useTranslation();
  const rtl = isRtl(i18n.language);

  return (
    <ConfigProvider locale={rtl ? urPK : enUS} direction={rtl ? 'rtl' : 'ltr'} theme={salesTheme}>
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
